var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M19.3,9.8h-0.5l-1.4,1.4l-2.9-2.8L14.9,8c0.1-0.1,0.1-0.4,0-0.5l-0.6-0.6c-0.6-0.5-1.4-0.5-2,0l-1.7,1.7 c-0.3,0.2-0.4,0.6-0.4,0.9c0,0.4,0.1,0.7,0.4,1l0.6,0.6h0.6l0.4-0.4l2.8,2.8l-1.4,1.4c-0.1,0.2-0.1,0.3,0,0.5l2.7,2.7 c-0.5,0.5-0.7,1.2-0.7,1.9c-0.1,0.6,0.1,1.2,0.5,1.6c-0.5,1.1-0.7,2.3-0.7,3.5c0,2.9,1.3,5.7,3.7,7.5l-1.5,3.6 c-0.3,0-0.7,0.1-0.9,0.4c-0.3,0.3-0.5,0.7-0.5,1.1v0.4c0,0.2,0.2,0.4,0.4,0.4h12.1c0.2,0,0.4-0.2,0.4-0.4v-0.4 c0-0.4-0.2-0.8-0.5-1.1c-0.2-0.3-0.6-0.4-0.9-0.4L27,34.5c2.3-0.5,4.4-1.8,5.9-3.7h0.3c0.8,0,1.5-0.7,1.6-1.5V29 c0-0.2-0.2-0.4-0.4-0.4h-6.7c-0.2,0-0.3,0.2-0.3,0.4v0.3c0,0.8,0.6,1.4,1.4,1.5c-0.9,0.6-1.9,0.9-2.9,1l-0.5-1.2 c-0.1-0.2-0.2-0.3-0.4-0.3h-4.3c-1.6-1.2-2.5-3.2-2.5-5.2c0-0.7,0.2-1.4,0.4-2.1c0.7,0,1.4-0.3,2-0.7l2.6,2.6h0.6l1.4-1.4l2.4,2.4 c0.2,0.2,0.5,0.3,0.8,0.3c0,0.2,0,0.3,0.1,0.4H29l1.6-1.7c0.2-0.1,0.2-0.3,0-0.5h-0.3c0-0.3-0.1-0.5-0.3-0.7l-2.5-2.4l1.4-1.4 l0.2-0.2l-0.2-0.3L19.3,9.8z M12.7,10.2L14,8.9l2.8,2.8L15.5,13L12.7,10.2z M28,37.1c0.2,0.2,0.3,0.4,0.3,0.6H17 c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.3,0.7-0.3h9.5C27.6,36.8,27.9,36.9,28,37.1z M30,30.8h1.9c-1.3,1.6-3.2,2.6-5.2,3l-0.5-1.3 C27.6,32.3,28.9,31.7,30,30.8z M24.8,31.1l2.1,5h-8.5l2.1-5H24.8z M19.9,30.6l-0.5,1.3c-2.1-1.6-3.3-4.1-3.3-6.8c0-1,0.2-2,0.5-2.9 c0.4,0.3,0.8,0.6,1.3,0.7c-0.3,0.7-0.4,1.4-0.4,2.2C17.5,27.2,18.4,29.2,19.9,30.6z M18.6,22.2c-1.2,0.3-2.5-0.5-2.7-1.8 c-0.3-1.2,0.5-2.5,1.8-2.7c0.3-0.1,0.6-0.1,1,0c1.2-0.3,2.5,0.5,2.7,1.8s-0.5,2.5-1.8,2.7C19.2,22.3,18.9,22.3,18.6,22.2z  M29.4,24.1c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.3-0.2,0.4L29,25.4c-0.2,0.2-0.6,0.2-0.8,0L25.7,23l1.3-1.3L29.4,24.1z M28.2,19.6 l-4.7,4.5l-2.4-2.4c0.3-0.5,0.6-1.1,0.6-1.7c0-1.7-1.3-3-3-3c0,0-0.1,0-0.1,0c-0.7,0-1.3,0.2-1.8,0.6l-2.4-2.4l1.4-1.4l1.8-1.8 l1.4-1.4L28.2,19.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M18.6,17.7c-1.2-0.3-2.5,0.5-2.7,1.8c-0.3,1.2,0.5,2.5,1.8,2.7c0.3,0.1,0.6,0.1,1,0c1.2,0.3,2.5-0.5,2.7-1.8 s-0.5-2.5-1.8-2.7C19.2,17.6,18.9,17.6,18.6,17.7z M19.6,20.9c-0.3,0.3-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4c-0.5-0.5-0.5-1.4,0-1.9 c0.6-0.5,1.4-0.5,2,0C20.1,19.5,20.1,20.4,19.6,20.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M17.6,19c-0.5,0.5-0.5,1.4,0,1.9c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.5-0.5,0.5-1.4,0-1.9 C19,18.5,18.2,18.5,17.6,19z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M25.7,23l2.5,2.4c0.2,0.2,0.6,0.2,0.8,0l0.4-0.5c0.2-0.1,0.2-0.2,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4L27,21.7 L25.7,23z"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "16.8,11.7 14,8.9 12.7,10.2 15.5,13 "
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M19,10.6L17.6,12l-1.8,1.8l-1.4,1.4l2.4,2.4c0.5-0.4,1.1-0.6,1.8-0.6c1.7-0.1,3,1.2,3.1,2.9c0,0,0,0.1,0,0.1 c0,0.6-0.3,1.2-0.6,1.7l2.4,2.4l4.7-4.5L19,10.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M18.4,36.1h8.5l-2.1-5h-4.3L18.4,36.1z M23.6,32c0.5,0.5,0.5,1.4,0,1.9c-0.3,0.3-0.6,0.4-1,0.4 c-0.3,0-0.7-0.1-0.9-0.4c-0.5-0.4-0.6-1.2-0.2-1.7c0.1-0.1,0.1-0.2,0.2-0.2C22.2,31.5,23.1,31.5,23.6,32z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M21.7,32c-0.5,0.4-0.6,1.2-0.2,1.7c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0.3,0.6,0.4,0.9,0.4c0.4,0,0.7-0.1,1-0.4 c0.5-0.5,0.5-1.4,0-1.9C23.1,31.5,22.2,31.5,21.7,32z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M17.9,36.8c-0.3,0-0.5,0.1-0.7,0.3c-0.1,0.2-0.2,0.4-0.2,0.6h11.3c0-0.2-0.1-0.4-0.3-0.6 c-0.1-0.2-0.4-0.3-0.6-0.3H17.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M17.9,22.9c-0.5-0.1-0.9-0.4-1.3-0.7c-0.3,0.9-0.5,1.9-0.5,2.9c0,2.7,1.2,5.2,3.3,6.8l0.5-1.3 c-1.5-1.4-2.4-3.4-2.4-5.5C17.5,24.3,17.6,23.6,17.9,22.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M26.2,32.5l0.5,1.3c2-0.4,3.9-1.4,5.2-3H30C28.9,31.7,27.6,32.3,26.2,32.5z"
});

function SvgLabEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabEquipment);
export default __webpack_public_path__ + "static/media/lab_equipment.54677451ab9a9d365da9bec913bfae9f.svg";
export { ForwardRef as ReactComponent };